import { SELECT_TYPE } from "../constant";

const getTitle = (query, selectedType, typeDetails) => {
  const { langCode = "en" } = query || {};
  let title = "";

  if (selectedType === SELECT_TYPE.AGENT) {
    let { address, person_name: name } = typeDetails || {};
    let { city, state_code } = address || {};

    city = city?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
    state_code = state_code?.toUpperCase();
    name = name?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());

    if (city && state_code && name) {
      title =
        langCode === "es"
          ? `${name} - ${city}, ${state_code} Agente de Bienes Raíces | realtor.com®`
          : `${name} - ${city}, ${state_code} Real Estate Agent | realtor.com®`;
    } else {
      title =
        langCode === "es"
          ? `${name || ""} - Agente de Bienes Raíces en su Área - realtor.com®`
          : `${name || ""} - Real Estate Agent in Your Area | realtor.com®`;
    }
  } else if (selectedType === SELECT_TYPE.TEAM) {
    const { team_bio } = typeDetails || {};
    let { address, name } = team_bio || {};
    let { city, state_code } = address || {};

    city = city?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
    state_code = state_code?.toUpperCase();
    name = name?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());

    if (city && state_code && name) {
      title =
        langCode === "es"
          ? `${name} - ${city}, ${state_code} Agente de Bienes Raíces | realtor.com®`
          : `${name} Real Estate Team in ${city}, ${state_code} | realtor.com®`;
    } else {
      title =
        langCode === "es"
          ? `${name || ""} - Agente de Bienes Raíces en su Área - realtor.com®`
          : `${name || ""} Real Estate Team in Your Area | realtor.com®`;
    }
  } else {
    let { address, name } = typeDetails || {};
    let { city, state_code } = address || {};

    city = city?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
    state_code = state_code?.toUpperCase();
    name = name?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());

    if (city && state_code && name) {
      title =
        langCode === "es"
          ? `${name} - ${city}, ${state_code} Agente de Bienes Raíces | realtor.com®`
          : `${name} Real Estate Agency in ${city}, ${state_code} | realtor.com®`;
    } else {
      title =
        langCode === "es"
          ? `${name || ""} - Agente de Bienes Raíces en su Área - realtor.com®`
          : `${name || ""} Real Estate Agency in Your Area | realtor.com®`;
    }
  }
  return title;
};

const getDescription = (query, selectedType, typeDetails) => {
  const { langCode = "en" } = query || {};
  let description = "";

  if (selectedType === SELECT_TYPE.AGENT) {
    let { address, person_name: name } = typeDetails || {};
    let { city, state_code } = address || {};

    city = city?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
    state_code = state_code?.toUpperCase();
    name = name?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());

    if (city && state_code && name) {
      description =
        langCode === "es"
          ? `Encuentre agente de bienes raíces y Realtor® ${name} en ${city}, ${state_code}, en Realtor.com®, su fuente para encontrar los profesionales en bienes raíces mejor calificados.`
          : `Find real estate agent & Realtor® ${name} in ${city}, ${state_code} on realtor.com®, your source for top rated real estate professionals.`;
    } else {
      description =
        langCode === "es"
          ? `Encuentre agente de bienes raíces y Realtor® ${name ||
              ""} su ciudad en Realtor.com®, su fuente para encontrar los profesionales en bienes raíces mejor calificados.`
          : `Find real estate agent & Realtor® ${name ||
              ""} in your city on Realtor.com®, your source for top rated real estate professionals.`;
    }
  } else if (selectedType === SELECT_TYPE.TEAM) {
    const { team_bio } = typeDetails || {};
    let { address, name } = team_bio || {};
    let { city, state_code } = address || {};

    city = city?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
    state_code = state_code?.toUpperCase();
    name = name?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());

    if (city && state_code && name) {
      description =
        langCode === "es"
          ? `Encuentre agente de bienes raíces y Realtor® ${name} en ${city}, ${state_code}, en Realtor.com®, su fuente para encontrar los profesionales en bienes raíces mejor calificados.`
          : `Find real estate team ${name} in ${city}, ${state_code} on Realtor.com®, your source for top rated real estate professionals.`;
    } else {
      description =
        langCode === "es"
          ? `Encuentre agente de bienes raíces y Realtor® ${name ||
              ""} su ciudad en Realtor.com®, su fuente para encontrar los profesionales en bienes raíces mejor calificados.`
          : `Find real estate team ${name ||
              ""} in your city on realtor.com®, your source for top rated real estate professionals.`;
    }
  } else {
    let { address, name } = typeDetails || {};
    let { city, state_code } = address || {};

    city = city?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
    state_code = state_code?.toUpperCase();
    name = name?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());

    if (city && state_code && name) {
      description =
        langCode === "es"
          ? `Encuentre agente de bienes raíces y Realtor® ${name} en ${city}, ${state_code}, en Realtor.com®, su fuente para encontrar los profesionales en bienes raíces mejor calificados.`
          : `Find real estate agency ${name} in ${city}, ${state_code} on realtor.com®, your source for top rated real estate professionals.`;
    } else {
      description =
        langCode === "es"
          ? `Encuentre agente de bienes raíces y Realtor® ${name ||
              ""} su ciudad en Realtor.com®, su fuente para encontrar los profesionales en bienes raíces mejor calificados.`
          : `Find real estate agency ${name ||
              ""} in your city on realtor.com®, your source for top rated real estate professionals.`;
    }
  }
  return description;
};

const getCanonical = (query, selectedType, typeDetails) => {
  const { profileId, langCode } = query || {};
  let canonical = "";
  if (selectedType === SELECT_TYPE.AGENT) {
    if (profileId) {
      canonical =
        langCode === "es"
          ? `https://www.realtor.com/realestateagents/es/${profileId}`
          : `https://www.realtor.com/realestateagents/${profileId}`;
    } else {
      canonical =
        langCode === "es"
          ? `https://www.realtor.com/realestateagents/es/${typeDetails?.id}`
          : `https://www.realtor.com/realestateagents/${typeDetails?.id}`;
    }
  } else if (selectedType === SELECT_TYPE.TEAM) {
    if (profileId) {
      canonical =
        langCode === "es"
          ? `https://www.realtor.com/realestateteam/es/${profileId}`
          : `https://www.realtor.com/realestateteam/${profileId}`;
    } else {
      canonical =
        langCode === "es"
          ? `https://www.realtor.com/realestateteam/es/${typeDetails?.team_bio?.id}`
          : `https://www.realtor.com/realestateteam/${typeDetails?.team_bio?.id}`;
    }
  } else {
    if (profileId) {
      canonical =
        langCode === "es"
          ? `https://www.realtor.com/realestateagency/es/${profileId}`
          : `https://www.realtor.com/realestateagency/${profileId}`;
    } else {
      canonical =
        langCode === "es"
          ? `https://www.realtor.com/realestateagency/es/${typeDetails?.id}`
          : `https://www.realtor.com/realestateagency/${typeDetails?.id}`;
    }
  }
  return canonical;
};
export const getSeoMetaLDP = (query, selectedType, typeDetails) => {
  const title = getTitle(query, selectedType, typeDetails);
  const canonical_url = getCanonical(query, selectedType, typeDetails);
  const description = getDescription(query, selectedType, typeDetails);
  const metaData = {
    title,
    canonical_url,
    description,
  };

  return metaData;
};
